import { store } from '../../../../../../../../../store';

export const getCategoryTitle = (categoryId) => {
  const state = store.getState();
  if (categoryId && categoryId !== -1) {
    const categories = state?.services?.categories;
    const findCategory = categories.find((category) => category.id === categoryId);
    if (findCategory) {
      return findCategory.title;
    }
  }
  return null;
};

/**
 *
 * @name getSelectedValue
 * @param {object} selected
 * @param {array} categories
 * @returns {null|{label: string, value: number}|{label: *, value: *}}
 */
export const getSelectedValue = (selected, categories) => {
  if (selected.assign === -1) {
    const findCategory = categories.find((category) => category.title === selected.category_title);
    if (findCategory) {
      return {
        label: findCategory.title,
        value: findCategory.id,
      }
    }
    return {
      label: selected.category_title,
      value: -1,
    }
  }

  if (selected.assign === 0) {
    return {
      label: 'Not assigned',
      value: 0,
    }
  }

  if (selected.assign) {
    const findCategory = categories.find((category) => category.id === selected.assign);
    if (findCategory) {
      return {
        label: findCategory.title,
        value: findCategory.id,
      }
    }
  }
  return null;
}
